import {
  Table,
  Button,
  Input,
  Form,
  Typography,
  Popconfirm,
  message,
  Tooltip,
  Select,
  Modal,
  Upload,
  Spin,
} from "antd";
import { useState, useEffect } from "react";
import axios from "axios";
import "..//TableAdjustments/AdjTable.css";
import * as XLSX from "xlsx";
import {
  ReloadOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  RollbackOutlined,
  SearchOutlined
} from "@ant-design/icons";
import Cookies from "js-cookie";
import { DiscardAllAdjustmentsApi } from "../../Repository/AdjustmentsRepository";
import { ErrorMessage, StringValidations, SuccessMessage } from "../../Utils/Utils";


const MyTable = (props) => {
  const { dataSource, setDataSource, fetchData, PayFrequency } = props;
  const [form] = Form.useForm();
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const [editingKey, setEditingKey] = useState("");
  const [ConfirmationFlag, setConfirmationFlag] = useState(false);
  const [PayDates, setPayDates] = useState([]);
  const [AdjUploadFlag, setAdjUploadFlag] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [manualLoadingFileName, setManualLoadingFileName] = useState('');
  const [uploadSpinLoader, setUploadSpinLoader] = useState(false);
  const [selectedPayDate, setSelectedPayDate] = useState();
  const [showRollbackModal, setShowRollbackModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedRecordForRollback, setSelectedRecordForRollback] = useState(null);
  const [loading, setLoading] = useState(false);

  //State variable for holding search text in Adjustments Table
  const [SearchAdjustmentTable, setSearchAdjustmentTable] = useState("");

  const isEditing = (record) => record.Ticket_Number === editingKey;
  const { Search } = Input;
  useEffect(() => {
    fetchData();
  }, [PayFrequency]);

  const handleEdit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.Ticket_Number);
  };

  const handleSave = async (Ticket_Number) => {
    const CurrentRowData = await form.getFieldValue();

    try {
      const url = `${process.env.REACT_APP_BASE_URL}Spectranet/updateGridData`;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${jwtToken}`,
        },
      };
      const response = await axios.put(url, CurrentRowData, config);
      if (response.data.isSuccess == true) {
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
      fetchData()
    } catch (error) {
      console.error(error);
    }
    setEditingKey("");
  };

  const handleCancel = () => {
    setEditingKey("");
  };

  //Delete Adjustment Record
  const DeleteAdjustmentRecord = async (record) => {
    // console.log(record);
    try {
      const url =
        `${process.env.REACT_APP_BASE_URL}Spectranet/DeleteGridData?Ticket_Number=` +
        record.Ticket_Number;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${jwtToken}`,
        },
      };
      const response = await axios
        .delete(url, config)
        .then((response) => response);
      // console.log(response);
      // if (response.status === 200) {
      //   response.data == "Success"
      //     ? message.success(
      //         `Ticket ${record.Ticket_Number} is Successfully Deleted`
      //       )
      //     : message.warning(response.data);
      // }
      if (response.data.isSuccess == true) {
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
      fetchData();
    } catch (error) {
      message.error("Please Try Again");
    }
  };
  const handleRollBackConfirmation = (record) => {
    setSelectedRecord(record);
    setSelectedRecordForRollback(record);
    setShowRollbackModal(true);
  };

  //Roll Back Adjustment
  const RollBackAdjustment = async (record) => {

    const recordForRollback = selectedRecordForRollback;

    if (!recordForRollback) {
      return;
    }
    try {
      const url = `${process.env.REACT_APP_BASE_URL}Spectranet/RollBackData`;
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${jwtToken}`,
      };
      const requestBody = [
        {
          ...recordForRollback,
        },
      ];

      const response = await axios
        .delete(url, {
          headers: headers,
          data: requestBody,
        })

        .then((response) => response);
      // console.log(response);
      if (response.data.isSuccess == true) {
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
      fetchData();
    } catch (error) {
      message.error("Please Try Again");
    } finally {
      // Close the confirmation modal regardless of success or error
      setShowRollbackModal(false);
    }
  };
  const handleCancelRollBack = () => {
    // Close the confirmation modal without performing the rollback action
    setShowRollbackModal(false);
  };
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please Input ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  //Filter Feature for Grid Layout
  const filterProps = () => (
    {
      filteredValue: [SearchAdjustmentTable],
      onFilter: (value, record) => {
        return (
          String(record.FileNumber).toLowerCase().includes(value.toLowerCase()) ||
          String(record.Emp_Name).toLowerCase().includes(value.toLowerCase())
        )
      }
    }
  )

  const SearchFileNumber = (value) => {
    setSearchAdjustmentTable(value);
  }

  const columns = [
    {
      title: "FileNumber",
      dataIndex: "FileNumber",
      fixed: "left",
      width: 120,
      // editable: true,
      ...filterProps()
    },
    {
      title: "Emp_Name",
      dataIndex: "Emp_Name",
      // editable: true,
      fixed: "left",
      width: 100,
      className: 'ellipsis-column',
      sorter: (a, b) => a.Emp_Name.localeCompare(b.Emp_Name),
      sortDirections: ['descend', 'ascend'],
      showSorterTooltip: false,
    },
    {
      title: "Client",
      dataIndex: "Client",
      // editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Ticket Number",
      dataIndex: "Ticket_Number",
      // editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Category",
      dataIndex: "Category",
      editable: true,
      width: 100,
      className: 'ellipsis-column',
      sorter: (a, b) => a.Category.localeCompare(b.Category),
      sortDirections: ['descend', 'ascend'],
      showSorterTooltip: false,
    },
    {
      title: "PayDate",
      dataIndex: "PayDate",
      // editable: true,
      width: 100,
      className: 'ellipsis-column',
      render: (text) => {
        let SplitArray = text.split("T");
        return <span>{SplitArray[0]}</span>
      }
    },
    {
      title: "CoCode",
      dataIndex: "CoCode",
      // editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Period",
      dataIndex: "Period",
      // editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "RateType",
      dataIndex: "RateType",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "PayRate",
      dataIndex: "PayRate",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "TempRate",
      dataIndex: "TempRate",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Flsa",
      dataIndex: "Flsa",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "CheckSequence",
      dataIndex: "CheckSequence",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "RT_Hrs",
      dataIndex: "RT_Hrs",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "OR_Hrs",
      dataIndex: "OR_Hrs",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "DT_Hrs",
      dataIndex: "DT_Hrs",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Salary",
      dataIndex: "Salary",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Holiday_Hrs",
      dataIndex: "Holiday_Hrs",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Sick_Hrs",
      dataIndex: "Sick_Hrs",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "PTO_Hrs",
      dataIndex: "PTO_Hrs",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Covid_Hrs",
      dataIndex: "Covid_Hrs",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Training_Hrs",
      dataIndex: "Training_Hrs",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Misc_Earnings",
      dataIndex: "Misc_Earnings",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Gym_Amount",
      dataIndex: "Gym_Amount",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "FMLA_Amount",
      dataIndex: "FMLA_Amount",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Sevpay_Amount",
      dataIndex: "Sevpay_Amount",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Bonus_Amount",
      dataIndex: "Bonus_Amount",
      editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      editable: true,
      width: 100,
      className: 'ellipsis-column'
    },
    {
      title: "Update_date",
      dataIndex: "Update_date",
      // editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Adjustment_Status",
      dataIndex: "Adjustment_Status",
      // editable: true,
      width: 150,
      className: 'ellipsis-column'
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "edit",
      fixed: "right",
      width: 100,
      render: (_, record) => {
        const editable = isEditing(record);
        // console.log(record);
        return record.Adjustment_Status.trim().toLowerCase() === "success" ? (
          <>
            <Tooltip title="Click to RollBack this Adjustment" color="blue">
              <RollbackOutlined
                className="rollback-icon"
                onClick={() => {
                  handleRollBackConfirmation(record);
                  setSelectedPayDate();
                }}
              />
            </Tooltip>
            <Modal
              open={showRollbackModal}
              onOk={() => RollBackAdjustment()}
              onCancel={handleCancelRollBack}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <ExclamationCircleOutlined
                  style={{
                    fontSize: "20px",
                    color: "#ffb703",
                    marginRight: "10px",
                  }}
                />
                <p>Are you sure you want to Rollback?</p>
              </div>
            </Modal>
          </>
        ) : editable ? (
          <span>
            <Popconfirm
              title="Sure to Save?"
              placement="topRight"
              onConfirm={() => handleSave(record.Ticket_Number)}
            >
              <a>
                <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
              </a>
            </Popconfirm>

            <Typography.Link
              onClick={() => handleCancel()}
              style={{
                marginRight: 8,
              }}
            >
              <CloseOutlined style={{ color: "red" }} />
            </Typography.Link>
          </span>
        ) : (
          <div>
            <Typography.Link
              disabled={editingKey !== ""}
              onClick={() => handleEdit(record)}
            >
              <EditOutlined />
            </Typography.Link>
            <Popconfirm
              title="Sure to Delete?"
              placement="topRight"
              onConfirm={() => DeleteAdjustmentRecord(record)}
            >
              <a>
                <DeleteOutlined
                  style={{ color: "#fa5946", marginLeft: "10px" }}
                />
              </a>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  //Get PayDate Dates
  const GetPayDates = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}Spectranet/GetDates`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${jwtToken}`,
      },
    };

    const PayDatesResponse = await axios
      .get(url, config)
      .then((response) => response.data);
    setPayDates(
      PayDatesResponse.map((EachDate) => ({
        label: new Date(EachDate).toLocaleDateString(),
        value: EachDate,
      }))
    );
  };

  const handleFinalSave = () => {
    setLoading(true);
    try {
      // console.log(dataSource)
      const dataToSend = dataSource.map((record) => {
        const data = {};
        columns.forEach((column) => {
          if (record.hasOwnProperty(column.dataIndex)) {
            data[column.dataIndex] = record[column.dataIndex];
          }
        });
        return data;
      });

      const url = `${process.env.REACT_APP_BASE_URL}Spectranet/PostDataToMasterFile`;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${jwtToken}`,
        },
      };
      axios
        .post(url, dataSource, config)
        .then((response) => {

          if (response.data.isSuccess == true) {
            message.success(response.data.message);

          } else {
            message.error(response.data.message);
          }
          fetchData();
          setConfirmationFlag(false);
          GetPayDates();
          setSelectedPayDate();
        })
        .catch((error) => {
          // console.error("API error:", error);
          message.error("Failed to save data");
          setSelectedPayDate();
        });

    }
    catch { } finally {
      setLoading(false);
    }

  };

  //Final Save Actions
  const ConfirmationToSaveInMaster = () => {
    setConfirmationFlag(true);
  };

  const AbortSave = () => {
    setConfirmationFlag(false);
  };

  const GetDataForPayDate = async (SelectedPayDate) => {
    if (SelectedPayDate != undefined) {
      setSelectedPayDate(SelectedPayDate);
      const url =
        `${process.env.REACT_APP_BASE_URL}Spectranet/GetSuccessData?Date=` +
        SelectedPayDate;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${jwtToken}`,
        },
      };
      const GetSuccessData = await axios
        .get(url, config)
        .then((response) => { return response.data });
      setDataSource(GetSuccessData);

    }
    else{
      setSelectedPayDate(undefined);
      fetchData();
    }
  };
  // Function to download an Excel template with default headers
  const downloadExcelTemplate = () => {
    // Array of default headers
    const headers = [
      "Category",
      "PayDate",
      "CoCode",
      "FileNumber",
      "Ticket_Number",
      "Emp_Name",
      "Client",
      "Period",
      "RateType",
      "PayRate",
      "TempRate",
      "Flsa",
      "CheckSequence",
      "Pay_Frequency",
      "RT_Hrs",
      "OR_Hrs",
      "DT_Hrs",
      "Salary",
      "Holiday_Hrs",
      "Sick_Hrs",
      "PTO_Hrs",
      "Covid_Hrs",
      "Training_Hrs",
      "Misc_Earnings",
      "Gym_Amount",
      "FMLA_Amount",
      "Sevpay_Amount",
      "Bonus_Amount",
      "Notes",
    ];

    // Create a worksheet using the headers
    const worksheet = XLSX.utils.aoa_to_sheet([headers]);

    // Create a new workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Convert the workbook to a buffer (binary data)
    const excelBuffer = XLSX.write(workbook, { type: "buffer" });

    // Create a Blob (binary large object) from the buffer
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a download link and trigger the download
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "AdjustmentTemplate.xlsx"; // The file will be downloaded with this name
    downloadLink.click();
  };

  // Function to upload manual adjustments using an Excel file
  const UploadManualAdjustment = async (options) => {
    // Set a flag to indicate that an upload is in progress
    setAdjUploadFlag(true);

    // Accessing file from upload action
    const { file, onSuccess, onError } = options;

    // Check if the selected file is an Excel file (xls or xlsx)
    if (
      file &&
      (file.type !== "application/vnd.ms-excel" &&
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    ) {
      message.error("Please upload only .xls or .xlsx files.");
      setAdjUploadFlag(false);
      return;
    }

    //Creating FormData Format to make a HTTP request

    const updatedFile = { file, status: "uploading" }
    const formData = new FormData();
    formData.append("file", file);

    // Read the uploaded Excel file data
    const reader = new FileReader();

    // Wrap the reader.onload callback in an async function
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      // Assuming the first sheet in the Excel file contains the data with headers in the first row
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to an array of objects (header: value)
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Assuming the first row contains the headers
      const uploadedHeaders = rows[0];

      // Define the expected headers
      const expectedHeaders = [
        "Category",
        "PayDate",
        "CoCode",
        "FileNumber",
        "Ticket_Number",
        "Emp_Name",
        "Client",
        "Period",
        "RateType",
        "PayRate",
        "TempRate",
        "Flsa",
        "CheckSequence",
        "Pay_Frequency",
        "RT_Hrs",
        "OR_Hrs",
        "DT_Hrs",
        "Salary",
        "Holiday_Hrs",
        "Sick_Hrs",
        "PTO_Hrs",
        "Covid_Hrs",
        "Training_Hrs",
        "Misc_Earnings",
        "Gym_Amount",
        "FMLA_Amount",
        "Sevpay_Amount",
        "Bonus_Amount",
        "Notes",
        // Add all the other expected headers here
      ];

      // Compare the uploaded headers with the expected headers
      const areHeadersMatching = JSON.stringify(uploadedHeaders) === JSON.stringify(expectedHeaders);

      if (!areHeadersMatching) {
        setFileList([])
        message.error("Invalid headers. Please make sure the file headers match the expected headers.");
        setAdjUploadFlag(false);
        return;
      }

      // If headers match, continue with the file upload logic

      try {
        // Send the file using axios post request
        setManualLoadingFileName(file.name);
        const url =
          `${process.env.REACT_APP_BASE_URL}Spectranet/AdjustmentsExcelUpload?uname=` +
          userLogin + "&PayFrequency=" + PayFrequency;
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${jwtToken}`,
          },
        };
        const UploadResponse = await axios.post(url, formData, config);

        // Check the response status and show appropriate message
        if (UploadResponse.data.isSuccess == true) {
          onSuccess(file);
          const fileName = file.name;
          setSelectedFile(file);
          message.success(`${fileName} Uploaded Successfully`);
          updatedFile.status = "done";
          setFileList([updatedFile])
          setUploadSpinLoader(false)
          setManualLoadingFileName('')
        } else {

          onError(file);
          message.error(UploadResponse.data.message);
          updatedFile.status = "error";
          setFileList([updatedFile]);
          setUploadSpinLoader(false)
          setManualLoadingFileName('')

        }

        // Reset the upload loading flag and fetch data into the Grid
        setAdjUploadFlag(false);
        fetchData();
      } catch (error) {
        // Show an error message and reset the upload flag
        message.error("Please try again");
        setAdjUploadFlag(false);
        fetchData();
      }
    };

    // Start reading the file as an ArrayBuffer
    reader.readAsArrayBuffer(file);
  };
  const onRemove = (file) => {
    const newFileList = fileList.filter((item) => item.uid !== file.uid);
    setFileList(newFileList);
  };
  const itemRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (fileList.length > 0) {
      fileExists = true;
    }
    return <>
      <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", backgroundColor: "#f2f8fc", marginTop: "2px", borderRadius: "4px" }}>{fileExists ? fileList[0].file.name : null}<DeleteOutlined onClick={() => setFileList([])} /></div>
    </>;
  };
  useEffect(() => {
    GetPayDates();
  }, []);

  const handleDiscardAdjustments = async () => {
    const Response = await DiscardAllAdjustmentsApi(PayFrequency);
    if (Response != null) {
      if (Response.statusCode === 200) {
        SuccessMessage(Response.message);
      }
      else {
        ErrorMessage(Response.message);
      }
    }
    else {
      ErrorMessage("Unable to resolve request");
    }
    fetchData();
  }

  const GridTotalsColumns = () => {
    let requiredHOurs = ["hrs", "amount", "misc", "salary"];
    let hoursFields = columns.filter((data, index) => {
      return requiredHOurs.some((fieldsPrompt) =>
        data.dataIndex.toLowerCase().includes(fieldsPrompt)
      );
    });
    return hoursFields;
  }

  const GridSummationData = (pageData, column) => {
    let RequiredColumn = GridTotalsColumns().filter(data => data.dataIndex === column.dataIndex);
    if (RequiredColumn.length > 0) {
      let Total = 0 ;
      const ColumnName = RequiredColumn[0].dataIndex;
      pageData.forEach((data) => {
        if (StringValidations(data[ColumnName])) {
          Total =Total+ parseFloat(data[ColumnName]);
        }
      })
      return (Number.isInteger(Total))?Total:Total.toFixed(2);
    }
    else{
      return "";
    }
  }
  return (
    <div className="table-container">
      {/* Adjustment Upload,Default Template, Grid actions Container */}
      <div className="table-upload-actions">
        <div className="manual-adjustment-upload-container">

          <Search placeholder="Search Name/File Number" className="search-filenumber-button" allowClear style={{ width: 250 }} enterButton onSearch={(value) => SearchFileNumber(value)} onChange={(e) => SearchFileNumber(e.target.value)} />

          {/*Adjustment Default Template Button */}
          <Button
            style={{ marginRight: "15px" }}
            type="primary"
            onClick={downloadExcelTemplate}
            ghost
          >
            Download Template
          </Button>
          <div className="manual-adjustment-upload-dragger">
            {/*Adjustment Manual Upload Section */}
            <Upload.Dragger
              accept=".xls,.xlsx"
              customRequest={UploadManualAdjustment}
              itemRender={itemRender}
              fileList={fileList}
              onRemove={() => setFileList([])}

            >
              <div className="manual-adjustment-upload-dragger-label">
                <img
                  src="./Images/UploadIcon.png"
                  style={{ height: "20px" }}
                ></img>
                <p style={{ margin: "0px", marginRight: "10px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                  Adjustment Upload
                </p>
                {AdjUploadFlag ? (
                  <Spin
                    indicator={
                      <div style={{ alignItems: "center" }}>
                        <LoadingOutlined />
                      </div>
                    }
                  ></Spin>
                ) : (
                  <></>
                )}
              </div>
            </Upload.Dragger>
          </div>
        </div>
        <div className="table-refresh">
          {/*Paydate Selection Dropdown */}
          <Select
            value={selectedPayDate}
            className="paydate-dropdown"
            placeholder="Pay Date"
            options={PayDates}
            allowClear
            onChange={GetDataForPayDate}
          />
          {/*Refresh icon to get latest Adjustment data */}
          <Tooltip color="bue" title="Click to refresh Grid to get Draft Data">
            <ReloadOutlined
              onClick={() => {
                fetchData();
                setSelectedPayDate();
              }}
            />
          </Tooltip>
        </div>
      </div>
      <div style={{ marginTop: "35px" }}>
        <Form form={form} component={false}>
          <Table
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            fetchData={fetchData}
            dataSource={dataSource}
            className="editable-table"
            columns={mergedColumns}
            scroll={{ x: "max-content", y: 400 }}
            pagination={false}
            summary={(pageData) => {
              return (
                StringValidations(PayFrequency)?
                <Table.Summary fixed={"bottom"}>
                  <Table.Summary.Row style={{ textAlign: "center" }}>
                    {
                      columns.map((column, index) => (
                        <Table.Summary.Cell index={index}>
                          {GridSummationData(pageData, column)}
                        </Table.Summary.Cell>
                      ))
                    }
                  </Table.Summary.Row>
                </Table.Summary>
                :
                <></>
              )
            }}
          />
        </Form>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button className="verify-btn" onClick={ConfirmationToSaveInMaster}>
          Save To Master
        </Button>
        <Button className="discard-btn" onClick={() => handleDiscardAdjustments()}>
          Discard
        </Button>
      </div>
      <Modal
        open={ConfirmationFlag}
        onOk={handleFinalSave}
        onCancel={AbortSave}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <ExclamationCircleOutlined
            style={{ fontSize: "20px", color: "#ffb703", marginRight: "10px" }}
          />
          <p>Are you sure want to save?</p>
        </div>
        {loading && <Spin size="large" />}
      </Modal>
    </div>
  );
};
export default MyTable;
